export class Interestpayments {

    Id: number;
    PaymentNo : number;
    SavingsId:  number;
    CustomerName :  string;
    PaymentDate:  Date;
    PaymentTypeId:  number;
    PaymentBankId:  number;
    ChequeNo:  string;
    PrincipleAmount:  number;
    InterestAmount:  number;
    TotalAmount :  number;
    Remarks:  string;
    EmployeeId:  number;
    EmployeeBranchId:  number;
    CompanyId:  number;
    SaasId:  number;
    CreatedDate:  Date;
    ModifiedDate:  Date;
    IsActive:  number;
    Flag :number;
}
